import React from 'react';

const getAccentClass = (id) => {
  switch (id) {
    case 'moving': return 'accent-blue';
    case 'courier': return 'accent-green';
    case 'furniture': return 'accent-amber';
    case 'package': return 'accent-cyan';
    case 'fullload': return 'accent-slate';
    default: return 'accent-blue';
  }
};

const ServiceTypeGrid = ({ types, onSelect, currentMode, onClearMode }) => {
  return (
    <div className="service-grid-container">
      <div className="service-grid-header">
        <div className="service-mode-badge-container">
          <span className="service-mode-badge">
            {currentMode === 'instant' ? '⚡ Instant Booking' : '📄 Modtag Tilbud'}
          </span>
          <button className="service-mode-change-btn" onClick={onClearMode}>
            Skift metode
          </button>
        </div>
        <h2>Hvad skal du have flyttet?</h2>
      </div>

      <div className="service-cards-grid">
        {types.map((type) => (
          <div
            key={type.id}
            className={`service-card ${getAccentClass(type.id)}`}
            onClick={() => onSelect(type.id)}
          >
            <div className="service-icon">{type.icon}</div>
            <h3>{type.name}</h3>
            <p>{type.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceTypeGrid;
